import { Grid } from '@mui/material';
import { DraftCardHeader } from '../draft-card-header';
import { DraftCardFooter } from '../draft-card-footer';
import { styles } from './styles';
import { IDraftCard } from './types';

export const DraftCard = ({ headerProps, footerProps, children }: IDraftCard) => {
  return (
    <Grid sx={styles.container}>
      {headerProps && <DraftCardHeader {...headerProps} />}
      <Grid sx={styles.content}>
        <Grid sx={styles.itemsContainer}>{children}</Grid>
      </Grid>
      <DraftCardFooter {...footerProps} />
    </Grid>
  );
};
